import { render, staticRenderFns } from "./Item-ranking-center.vue?vue&type=template&id=05926746&scoped=true&lang=pug"
import script from "./Item-ranking-center.vue?vue&type=script&lang=js"
export * from "./Item-ranking-center.vue?vue&type=script&lang=js"
import style0 from "./Item-ranking-center.vue?vue&type=style&index=0&id=05926746&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05926746",
  null
  
)

export default component.exports